import React, { useState, useEffect } from "react";
import { format, isValid } from 'date-fns';
import { Grid } from '@material-ui/core';
import { Box, Card, CardContent, FormControl, InputLabel, Alert, AlertTitle, Select, MenuItem, Button } from '@mui/material';
import MainCard from '../components/MainCard';
import SelectTable from '../components/SelectTable';
import axios from "../../components/axios";
import CustomDatePicker from '../components/CustomDatePicker';
import { useNavigate } from 'react-router-dom';
import TextFieldCommon from '../components/Form/TextFieldCommon';


const columns = [
  { id: 'profile', label: 'profile', align: 'left'},
  { id: 'bikeFrameSerial', label: 'bikeFrameSerial', align: 'center'},
  { id: 'firmwareVersion', label: 'firmwareVersion', align: 'center'},
  { id: 'serial', label: 'serial', align: 'center'},
  { id: 'startPacketTime', label: 'startPacketTime', align: 'center'},
  { id: 'error', label: 'error', align: 'center'},
  { id: 'runningPacketTime', label: 'runningPacketTime', align: 'center'},
  { id: 'action', label: 'Download', align: 'center', action: true},
];

const BikeplusErlichPage = () => {
  const navigate = useNavigate();
  const [rows, setRows] = useState([]);
  const [showTable, setshowTable] = useState(false);
  const [showAlert, setshowAlert] = useState(false);
  const [selected, setSelected] = useState([]);
  const [clickCalendar, setclickCalendar] = useState(0);
  const [firmwareList, setFirmwareList] = useState([]);
  const [firmware, setFirmware] = useState("");
    function handleFirmware(e) {
        setFirmware(e.target.value);
    }
  const [search, setSearch] = useState("");
  function searchChange(e) {
    setSearch(e.target.value);
  }

  const [open, setOpen] = useState(false);
  const onChange = (ranges) => {
    if (clickCalendar === 0 ){
      setclickCalendar(clickCalendar+1)
    }else{
      setclickCalendar(0)
      if (ranges.startDate !== null && ranges.endDate !== null) {
        setOpen(false);
      }
    }
  };

  const [state, setState] = useState([
    {
      startDate: null,
      endDate: null,
      key: "selection"
    }
  ]);

  const styleButton = {
      backgroundColor: "#406599",
      color: "#fff",
      borderRadius: "5px",
      boxSizing: "border-box",
      width: "100px",
      height: "45px",
      fontFamily: '"Roboto", "sans-serif"',
      fontSize: "15px",
  };

  const styleField = {
    width: '100%',
  };

  const getFirmwareList = async () => {
    const response = await axios.post("/data/v1/bikeplus-erlich-firmware", null, { withCredentials: true});
    setFirmwareList(response.data.firmware_list);
  }

  useEffect(() => {
    getFirmwareList();
  }, []);

  const handleDownload = (id) => {
        var input_data = JSON.stringify({ item_id: id });
        axios.post('/data/v1/bikeplus-erlich-file', input_data, {withCredentials: true})
        .then(response => {
          if (response.data.message === "success") {
            window.open(response.data.url, "_blank");
          }else{
            alert(response.data.message);
          }
        })
        .catch(function(err){
          if (!err.response){
            alert(err);
          }else{
            if (err.response.status === 401){
              alert(err.response.data.message);
              navigate("/");
            }else if (err.response.status === 406) {
              if (err.response.data.user){
                localStorage.setItem("qbarn.user", JSON.stringify(err.response.data.user))
                navigate("/");
              }
            }else{
              console.log('error.response.status: ', err.response.status)
              console.log('error.response.status: ', err.response.data.message)
              alert(err.response.data.message)
            }
          }
        })
    };

  const handleQueryData = () => {
    if (search === "" && state[0].startDate === null && state[0].endDate === null && firmware === ""){
      alert("Please select query date range or keyword!");
    }else{
      setRows([]);
      setSelected([]);
      let startDateStr = "";
      let endDateStr = ""
      if (state[0].startDate !== null && isValid(state[0].startDate)) {
        startDateStr = format(state[0].startDate, "yyyy-MM-dd")
      }
      if (state[0].endDate !== null && isValid(state[0].endDate)) {
        endDateStr = format(state[0].endDate, "yyyy-MM-dd")
      }
      var input_data = JSON.stringify({ query: search, start_date: startDateStr,
        end_date: endDateStr, firmware: firmware })
      axios.post("/data/v1/bikeplus-erlich",input_data,{withCredentials: true})
      .then(response => {
            if (response.data.message === "success") {
              if (response.data.data !== null){
                setRows(response.data.data);
                setshowTable(true);
              }else{
                setshowAlert(true);
              }
            }else{
                alert(response.data.message);
            }
      }).catch(function(err){
        if (!err.response){
          alert(err);
        }else{
          if (err.response.status === 401){
            navigate("/");
          }else{
            alert(err.response.data.message)
          }
        }
      })
    }
  };

  const handleClear = () => {
    setSearch('');
  };
  return (
    <MainCard title={'Bike+ Erlich'}>
      <Card variant="outlined" sx={{ bgcolor: "white" }}>
      <CardContent>
      <Box sx={{ fontSize: '20px', color:"#406599", pb:'15px'}}>
          Bike+ Erlich
      </Box>

      <Grid container direction="row" justifyContent="space-around" alignItems="center" >
        <Grid item xs={2}>
          <FormControl style={styleField} >
          <InputLabel id="demo-simple-select-standard-label">Select Firmware</InputLabel>
            <Select
              id="firmwares"
              fullWidth
              value={firmware}
              onChange={handleFirmware}
              variant="filled"
            >
              {firmwareList.map((option) => (
                <MenuItem key={option.value} value={option.value}>
                  {option.label}
                </MenuItem>
              ))}
            </Select>
            </FormControl>
          </Grid>
        <Grid item xs={3}>
        <CustomDatePicker onChange={onChange} open={open} setOpen={setOpen} state={state} setState={setState}/>
        </Grid>
        <Grid item xs={3}>
          <TextFieldCommon search={search} searchChange={searchChange} handleClear={handleClear}/>
        </Grid>
        <Grid item xs={1}>
          <Button style={styleButton} onClick={handleQueryData}>Search</Button>
        </Grid>
      </Grid>
      </CardContent>
      </Card>
      { showTable && (<SelectTable
                      rows={rows}
                      columns={columns}
                      handleDownload={handleDownload}
                      selected={selected}
                      setSelected={setSelected}/>)}
      { showAlert && (<Card variant="outlined" sx={{ bgcolor: "white" }}><Alert severity="warning">
        <AlertTitle>Warning</AlertTitle>
        No data in this condition.
      </Alert></Card>)}
    </MainCard>

  );
};

export default BikeplusErlichPage;
